import {
  getEnterpriseVisits,
  getVisitsById
}
  from '~api/enterprise-visits'

export const state = () => ({
  visits: [],
  pages: {},
  currentVisitsDetails: {}
})

export const getters = {
  visitsGetter: state => state.visits,
  pageGetter: state => state.pages,
  currentVisitsDetailsGetter: state => state.currentVisitsDetails
}

export const actions = {
  async getVisitsAll ({
    commit
  }, params) {
    const data = await getEnterpriseVisits(params)
    const {
      visits,
      pages
    } = data

    commit('setVisits', visits)
    commit('setVisitsPage', pages)

    return data
  },
  async getVisitsDetailsById ({
    commit
  }, id) {
    const visit = await getVisitsById(id)
    commit('setCurrentVisitsDetails', visit)
  }
}

export const mutations = {
  setVisits (state, payload) {
    state.visits = payload
  },
  setVisitsPage (state, payload) {
    state.pages = payload
  },
  setCurrentVisitsDetails (state, payload) {
    state.currentVisitsDetails = payload
  }
}
